// Ship-date messaging for variants carrying a FUTURE custom.preorder_ship_date.
// The PDP and every collection card publish their variants into window.RW_PREORDER
// as { variantId: { d: "November 1", m: "preorder" | "back_in_stock" } }; this file
// owns the wording so the two phrasings live in ONE place. Edit copy here.
window.RW_PREORDER = window.RW_PREORDER || {};

window.rwPreorderCopy = function (entry) {
  if (!entry) return null;

  // Tolerate the older string-only map shape from a cached page.
  var when = typeof entry === 'string' ? entry : entry.d;
  var mode = (entry && entry.m) || 'preorder';
  if (!when) return null;

  if (mode === 'back_in_stock') {
    return {
      tag: 'Back in stock',
      cta: 'Order now -',
      note: 'Back in stock ' + when + '. Order now and it ships as soon as it lands - anything else in your order ships right away.',
      card: 'Back in stock ' + when,
      property: 'Back in stock ' + when
    };
  }

  return {
    tag: 'Pre-order',
    cta: 'Pre-order -',
    note: 'Ships on or after ' + when + '. Anything else in your order ships right away.',
    card: 'Pre-order - ships ' + when,
    property: 'On or after ' + when
  };
};

// Labels this feature owns, so a reset knows what it may overwrite.
window.RW_PREORDER_CTAS = ['Pre-order -', 'Order now -'];
